import getOr from 'lodash/fp/getOr'

import resourceAutocompleteField from '../resourceAutocompleteField'
import { injector as withReducer } from './reducer'
import { injector as withSaga } from './saga'
import { getAllActivities } from './routines'
import { selectActivitiesSortedEntities, isActivitiesAllRequesting } from './selectors'

const getActivityDescription = activity => {
  const text = getOr('', 'description')(activity)
  if (activity.is_warn) {
    return `${text}. (Siempre que desarrolles la actividad de una forma sostenible, ecológica y social)`
  }
  return text
}
const getActivityCode = getOr('', 'code')

const fetcher = ({ dispatch }) => dispatch(getAllActivities.trigger())

const ActivitiesField = resourceAutocompleteField({
  resourceSelector: selectActivitiesSortedEntities,
  requestingSelector: isActivitiesAllRequesting,
  fetcher,
  withReducerEnhancer: withReducer,
  withSagaEnhancer: withSaga,
  itemTextSelector: getActivityDescription,
  itemValueSelector: getActivityCode
})

export default ActivitiesField
